import { IconBarChart, IconMessageCircle } from './icons';

export const NOVA_IDS = {
    panel: 'nova-panel',
    input: 'nova-input',
    tab: (id) => `nova-tab-${id}`,
    tabpanel: (id) => `nova-tabpanel-${id}`,
};

export const TABS = [
    { id: 'chat', label: 'Chat', Icon: IconMessageCircle },
    { id: 'insights', label: 'Insights', Icon: IconBarChart },
];

export const MAX_QUESTION_LENGTH = 270;
export const GENERIC_ERROR = 'Foresee AI could not complete that request.';

export const RISKS_PROMPT = 'What are my top security risks?';
export const THREATS_PROMPT = 'Show threat activity from the last 24 hours';
export const COMPLIANCE_PROMPT = 'Generate a quick compliance report';
export const REPORT_PROMPT = 'Generate a detailed security report';
export const POSTURE_PROMPT = 'Give me an overview of my security posture by category';

export const QUICK_ACTIONS = [
    { title: 'Check security risks', description: 'Overview of current open risks', glyph: 'risk', prompt: 'Check my current security risks' },
    { title: 'Summarize threats', description: 'Latest activity across your assets', glyph: 'violation', prompt: 'Summarize recent threat activity' },
    { title: 'Generate report', description: 'Detailed security report for review', glyph: 'policy', prompt: REPORT_PROMPT },
    { title: 'Ask anything', description: 'Query your data in plain language', glyph: 'questions', prompt: null },
];

export const SUGGESTED = [
    'What decision should I make this week?',
    'What is my highest financial risk today?',
    'What should the board know right now?',
];

export const INSIGHT_ACTIONS = [
    { label: 'View top risks', glyph: 'risk', prompt: RISKS_PROMPT },
    { label: 'Compliance status', glyph: 'compliance', prompt: COMPLIANCE_PROMPT },
    { label: 'Recent threats', glyph: 'violation', prompt: THREATS_PROMPT },
    { label: 'Generate report', glyph: 'policy', prompt: REPORT_PROMPT },
];

export const STATUS_LABEL = { online: 'Online', offline: 'Offline', connecting: 'Connecting' };

export const SEVERITY_LABEL = { critical: 'Critical', high: 'High', medium: 'Medium', low: 'Low' };
